// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"c131f33e","20":"31a972fc","102":"1aaf9374","314":"da793277","677":"cf30b2ef","874":"c32f9d03","982":"06d1e1b4"}[chunkId] + ".chunk.js";
};